import { Component, ViewChild } from '@angular/core';
import { CartolaService } from '../../services/cartola.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ActionsService } from 'src/app/shared/services/actions.service';

import Swal from 'sweetalert2';
import { HoursOperationService } from '../../services/hours-operation.service';
import { Router } from '@angular/router';
import { CalculatorWithdrawComponent } from './components/calculator-withdraw/calculator-withdraw.component';
import { WithdrawAccountsStepComponent } from './components/withdraw-accounts-step/withdraw-accounts-step.component';
import { CuentaRetiro } from '../../interfaces/cuenta-retiro.interface';
import { WithdrawAccountService } from '../../services/withdraw-account.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';

@Component({
  selector: 'app-withdraw-balance',
  templateUrl: './withdraw-balance.component.html',
  styleUrls: ['./withdraw-balance.component.sass']
})
export class WithdrawBalanceComponent {
  hasAccounts = false;
  currentStep = 1;
  totalSteps = 3;
  isTransitioning = false;
  slideDirection: 'left' | 'right' = 'left';

  constructor(
    private cartolaService: CartolaService,
    private store: Store<AppState>,
    private actionService: ActionsService,
    private hourOperations: HoursOperationService,
    private router: Router,
    private withdrawAccountService: WithdrawAccountService,
    private spinner: SpinnerService
  ){
    const ref = this.spinner.start();
    this.validateAccounts();
    this.spinner.stop(ref);
  }

  @ViewChild('beneficiarioComponent') withdrawAccountsStepComponent: WithdrawAccountsStepComponent | undefined;
  @ViewChild('calculatorComponent') calculatorComponent: CalculatorWithdrawComponent | undefined;

  public subscription: Subscription = new Subscription();
  public user: any;
  public saldoActual = 0;
  public montoRetiro: number = 0;
  public accountSelected: CuentaRetiro | undefined;
  public userId: number | undefined= 0;
  estadoOperaciones = true;
  estadoStopOperacion = true;
  subscriptions: Subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(
      this.actionService.subjectTasaUSDT.subscribe(res=>{
        if(this.currentStep !== 1){
          Swal.fire({ title: 'Tasas actualizadas', text: 'Se han actualizado las tasas, será regresado al primer paso', icon: 'warning', confirmButtonColor: '#1e5a3f' });
          this.currentStep = 1;
        }
      })
    )
    this.subscription.add(
      this.store.select('auth').subscribe(({ user }: any) => {
        this.user = user;
        this.userId = user?.usuarioId;
        this.obtenerSaldo();
      })
    );
  }

  async validateAccounts(){
    let accounts = await this.withdrawAccountService.getWithdrawAccounts();
    if(accounts.length<=0){
      this.hasAccounts=false;
       Swal.fire(
        { confirmButtonColor: '#1e5a3f',
        icon: 'info',
        title: 'Atención',
        text:'Requieres crear una cuenta de retiro para realizar esta acción',
        showCancelButton: false,
      }
      );
      this.router.navigate(['/wallet/client/withdraw-accounts']);
    }else{
      this.hasAccounts=true;
    }
  }

  async validarEstado(){
    this.estadoOperaciones = await this.hourOperations.getEstadoOperacion('USDT');
    this.estadoStopOperacion = await this.hourOperations.getEstadoOperacion('USDT_STOP');
    const message =
      'Hemos cerrado operaciones, muchas gracias por preferirnos.';
    if(!this.estadoOperaciones){
      Swal.fire(
        { confirmButtonColor: '#1e5a3f',
        title: 'Operación cerrada',
        text:message,
      }
      );
      this.router.navigate(['/wallet']);
    }
    if(!this.estadoStopOperacion){
      Swal.fire(
        { confirmButtonColor: '#1e5a3f',
        title: 'Operación Pausada',
        text:'Volvemos en 10 min',
      }
      );
      this.router.navigate(['/wallet']);
    }
  }

  /**
   * 30/10/2026: se le pasa al resumen para volver a consultar el canal justo
   * antes de confirmar. `validarEstado` avisa y saca al cliente si está cerrado
   * o en pausa. Si la consulta falla no se bloquea, igual que al entrar.
   */
  operacionSigueAbierta = async (): Promise<boolean> => {
    try {
      await this.validarEstado();
    } catch {
      return true;
    }
    return !!this.estadoOperaciones && !!this.estadoStopOperacion;
  };

  async obtenerSaldo(){
    if(this.user?.usuarioId){
      const {saldo} = await this.cartolaService.getSaldoCliente(this.user.usuarioId);
      this.saldoActual = saldo;
    }
  }

  goToNextStep(): void {
    if (this.isTransitioning || this.currentStep >= this.totalSteps) return;
    this.slideDirection = 'left';
    this.isTransitioning = true;
    setTimeout(() => {
      this.currentStep++;
      this.isTransitioning = false;
    }, 300);
  }

  previousStep(): void {
    if (this.isTransitioning) return;
    if (this.currentStep > 1) {
      this.slideDirection = 'right';
      this.isTransitioning = true;
      setTimeout(() => {
        this.currentStep--;
        this.isTransitioning = false;
      }, 300);
    } else {
      this.router.navigate(['/wallet/home']);
    }
  }

  assignMontoRetiro( amount:number ){
    this.montoRetiro = amount;
  }

  assignAccount( account:CuentaRetiro ){
    this.accountSelected = account;
  }
}
